import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 32, className = "", once = true }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, margin: "-60px" }}
    transition={{ duration: 1, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className = "", immediate = false }) => (
  <span className={`block overflow-hidden ${className}`}>
    <motion.span
      className="block"
      initial={{ y: "115%" }}
      {...(immediate
        ? { animate: { y: 0 } }
        : { whileInView: { y: 0 }, viewport: { once: true } })}
      transition={{ duration: 1.2, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export const SectionHead = ({ eyebrow, chapter, title, dark = false, center = false }) => (
  <div className={center ? "text-center" : ""}>
    <Reveal>
      <div className={`flex items-center gap-4 ${center ? "justify-center" : ""}`}>
        {chapter && (
          <span className={`font-serif-display italic text-lg ${dark ? "text-[#C5A059]" : "text-[#9E7B36]"}`}>
            {chapter}
          </span>
        )}
        <span className={`block h-px w-12 bg-[#C5A059]`} />
        <span className="text-[11px] tracking-[0.3em] uppercase font-medium text-[#C5A059]" data-testid={`eyebrow-${eyebrow?.toLowerCase().replace(/\s+/g, "-")}`}>
          {eyebrow}
        </span>
      </div>
    </Reveal>
    <h2 className={`font-serif-display font-normal tracking-tight leading-[1.1] text-3xl sm:text-4xl lg:text-5xl mt-6 ${dark ? "text-[#F7F5F0]" : "text-[#1C1B18]"}`}>
      {title}
    </h2>
  </div>
);
